import React from 'react';
import Icon from '../../../components/AppIcon';

const TicketStats = ({ stats }) => {
  const statCards = [
    {
      label: 'Total Tickets',
      value: stats?.total || 0,
      icon: 'Inbox',
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10'
    },
    {
      label: 'Open',
      value: stats?.open || 0,
      icon: 'AlertCircle',
      color: 'text-yellow-500',
      bgColor: 'bg-yellow-500/10'
    },
    {
      label: 'In Progress',
      value: stats?.in_progress || 0,
      icon: 'Clock',
      color: 'text-orange-500',
      bgColor: 'bg-orange-500/10'
    },
    {
      label: 'Resolved',
      value: stats?.resolved || 0,
      icon: 'CheckCircle2',
      color: 'text-green-500',
      bgColor: 'bg-green-500/10'
    },
    {
      label: 'Urgent',
      value: stats?.urgent || 0,
      icon: 'AlertTriangle',
      color: 'text-red-500',
      bgColor: 'bg-red-500/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow"
        >
          <div className="flex items-center gap-3">
            <div className={`${stat?.bgColor} p-2 rounded-lg`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
            <div>
              <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
              <p className="text-xs text-muted-foreground">{stat?.label}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TicketStats;